import { gql } from '@apollo/client';

export interface ReceiptType {
  message_id: string;
  created: string;
  recipient: string;
}

export interface UserType {
  id: string;
  firstName: string;
  lastName: string;
  type: string;
}

export interface MessageType {
  uuid: string;
  content: string;
  type: string;
  created: string;
  users: UserType;
  conversations_read_receipts: ReceiptType[];
  conversationUuid: string;
}

export interface ConversationType {
  uuid: string;
  conversations_messages: MessageType[];
}

export interface GetConversationsWithMessagesAndUsersQueryResponse {
  conversations: ConversationType[];
}

export const GET_CONVERSATIONS_WITH_MESSAGES_AND_USERS = gql`
  query GetConversationsWithMessagesAndUsers($event_request_id: String!, $supplier_id: String!) {
    conversations(where: { event_request_id: { equals: $event_request_id }, supplier_id: { equals: $supplier_id } }) {
      uuid
      conversations_messages {
        uuid
        content
        type
        created
        users {
          id
          firstName
          lastName
          type
        }
        conversations_read_receipts {
          message_id
          created
          recipient
        }
      }
    }
  }
`;
